/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import React, { useContext, useEffect, useState } from "react";
import { MyContext } from "../../Context/MyProvider";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaStar } from "react-icons/fa";
import {
  MdCheck,
  MdOutlineErrorOutline,
  MdOutlineFileDownload,
  MdOutlineRemoveRedEye,
  MdPictureAsPdf,
} from "react-icons/md";
import Slider from "react-slick";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from "@mui/lab/TimelineOppositeContent";
import HomeIcon from "../../assets/Icon/home.svg";
import testtube from "../../assets/Icon/testtube.svg";
import clockcircle from "../../assets/Icon/clock-circle.svg";
import invoice from "../../assets/Icon/invoice.svg";
import packagebox from "../../assets/Icon/package-box.svg";
import { showToast } from "../../showTost";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";
import {
  LuChevronRight,
  LuCalendar,
  LuCreditCard,
  LuPhoneCall,
  LuClipboardList,
  LuUser,
  LuActivity,
} from "react-icons/lu";
import { IoChevronBackOutline, IoCloseSharp } from "react-icons/io5";

const PackageDetails = () => {
  const { t } = useTranslation();

  const { ApiBaseUrl, ImgBaseUrl, setIsLoginShow } = useContext(MyContext);
  const [labData, setLabData] = useState([]);
  const [appointData, setAppointData] = useState();
  const [isShow, setIsShow] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [detailsBox, setDetailsBox] = useState(false);
  const [packageData, setPackageData] = useState();
  const [showReport, setShowResport] = useState(false);
  const [reportData, setReportData] = useState();
  const [loading, setLoading] = useState(true);
  const [deviceCheck, setDeviceCheck] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const Data = location.state;

  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency || "$";
  const Userid = secureLocalStorage.getItem("Userid");

  const settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 770, settings: { slidesToShow: 6 } },
      { breakpoint: 430, settings: { slidesToShow: 4 } },
    ],
  };

  useEffect(() => {
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/lab_booking_detail`, {
          id: Userid,
          lab_book_id: Data.id,
        })
        .then((res) => {
          const { ResponseCode, lab, appoint } = res.data;
          // console.log("lab_booking_detail", res);
          if (ResponseCode === 200) {
            setLabData(lab);
            setAppointData(appoint);
            HandleStatusGet(appoint);
            setLoading(false);
          }
        })
        .catch(console.error);
    }
  }, []);

  const HandleStatusGet = (appoint) => {
    const status = appoint?.status;
    const statusListRaw = appoint?.status_list || [];
    const isHomeCollection = appoint?.home_col_status === "0";

    let steps;

    if (status !== "7") {
      const OrderSteps = [
        { id: 1, title: "Pending", dis: t("YourOrderPlaced") },
        { id: 2, title: "Accepted", dis: t("OrderPending") },
        { id: 3, title: "Collector Assigned", dis: t("CollectorAssigned") },
        { id: 4, title: "Ongoing", dis: t("OrderDelivering") },
        { id: 5, title: "Processing", dis: t("ProductDelivered") },
        { id: 6, title: "Completed", dis: t("OrderDelivered") },
      ];

      steps = OrderSteps.filter(
        (step) => !(isHomeCollection && step.id === 3),
      ).map((step) => {
        const match = statusListRaw.find((s) => s.s === step.id);
        return { ...step, date: match?.t || "-" };
      });
    } else {
      steps = [
        { id: 1, title: "Pending", dis: t("YourOrderPlaced") },
        {
          id: 7,
          title: "Cancelled",
          dis: appoint?.cancel_reason || appoint?.cancel_title,
        },
      ].map((step) => {
        const match = statusListRaw.find((s) => s.s === step.id);
        return { ...step, date: match?.t || "-" };
      });
    }

    setStatusList(steps);
  };

  const HandleShowResport = (item) => {
    if (item.r.length === 0) {
      showToast({
        title: t(
          "No lab report uploaded yet. You'll be notified once it's available.",
        ),
        id: "warning",
      });
      return;
    }
    setShowResport(true);
    setReportData(item);
  };

  const HandleShowReport = (item) => {
    const url = ImgBaseUrl + item;
    window.open(url, "_blank");
  };

  const handleDownload = (img) => {
    const googleMapsUrl = ImgBaseUrl + img;
    window.open(googleMapsUrl, "_blank");
  };

  const formatDateTime = (dateStr, timeStr) => {
    const [day, month, year] = dateStr.split("-");
    const dateTimeString = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${convertTo24Hour(timeStr)}`;
    const date = new Date(dateTimeString);
    return date.toLocaleString("en-US", {
      weekday: "short",
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const convertTo24Hour = (timeStr) => {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":");
    if (modifier === "PM" && hours !== "12")
      hours = String(parseInt(hours, 10) + 12);
    if (modifier === "AM" && hours === "12") hours = "00";
    return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}:00`;
  };

  const AudioCallHandler = async (code, phone) => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (!Userid) {
      setIsLoginShow(true);
      return;
    }
    try {
      const deviceList = await navigator.mediaDevices.enumerateDevices();
      let hasMicrophone = false;
      deviceList.forEach((device) => {
        if (device.kind === "audioinput") hasMicrophone = true;
      });
      if (!hasMicrophone) {
        setDeviceCheck(true);
        return;
      }
    } catch (error) {
      console.error("Error checking devices:", error);
    }
    window.location.href = `tel:${code + phone}`;
  };

  return (
    <div className="package-details-container w-full min-h-screen pb-[100px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto">
      {loading ? (
        <Loading
          CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]"
          index={0}
        />
      ) : (
        <div className="flex flex-col">
          {/* Header Navigation */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
            >
              <IoChevronBackOutline className="w-4 h-4" />
              <span className="font-medium text-sm">{t("Go Back")}</span>
            </button>

            <div className="flex items-center gap-2 text-sm text-slate-500">
              <span
                className="hover:text-indigo-650 font-medium transition-colors cursor-pointer"
                onClick={() => navigate("/dashbord")}
              >
                {t("Dashboard")}
              </span>
              <LuChevronRight className="w-3.5 h-3.5" />
              <span
                className="hover:text-indigo-650 font-medium transition-colors cursor-pointer"
                onClick={() => window.history.back()}
              >
                {t("Lab Bookings")}
              </span>
              <LuChevronRight className="w-3.5 h-3.5" />
              <span className="font-semibold text-slate-800">
                {t("Booking Details")}
              </span>
            </div>
          </div>

          {/* Appointment ID & Status Button */}
          <div className="flex items-center justify-between gap-4 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-indigo-50 border border-indigo-100 rounded-2xl flex items-center justify-center shrink-0">
                <LuClipboardList className="w-5 h-5 text-indigo-600" />
              </div>
              <div>
                <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block">
                  {t("Appointment ID")}
                </span>
                <h2 className="font-black text-slate-800 text-xl">
                  #{Data.id}
                </h2>
              </div>
            </div>
            <button
              onClick={() => {
                setIsShow(true);
                HandleStatusGet(appointData);
              }}
              className="inline-flex items-center gap-1.5 border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-600 hover:text-white font-bold text-sm px-4 py-2 rounded-full transition-all duration-200 active:scale-95"
            >
              <LuActivity className="w-4 h-4" />
              {t("Check Status")}
            </button>
          </div>

          {/* Main Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Left Column – Lab Info & Test Packages */}
            <div className="lg:col-span-2 flex flex-col gap-6">
              {/* Lab Details Card */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex items-start gap-5">
                <div className="w-20 h-20 rounded-2xl overflow-hidden border border-slate-150 shrink-0 shadow-inner bg-slate-50">
                  <ImageLoad
                    src={ImgBaseUrl + labData?.logo}
                    CustomeStyle="w-full h-full object-cover"
                    alt="logo"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-slate-800 text-lg line-clamp-1">
                    {labData?.name}
                  </h3>
                  <p className="text-slate-500 text-sm font-medium mt-0.5 line-clamp-1">
                    {labData?.address}
                  </p>
                  <div className="flex items-center gap-1.5 mt-2">
                    <FaStar className="text-amber-400 w-4 h-4 shrink-0" />
                    <span className="font-black text-slate-800 text-base">
                      {labData?.avg_star}
                    </span>
                    <span className="text-slate-400 text-xs font-medium">
                      ({labData?.tot_review}+ {t("Rating")})
                    </span>
                  </div>
                </div>
              </div>

              {/* Test & Package Cards */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-4">
                <h3 className="font-bold text-slate-800 text-lg">
                  {t("Test Details & Package Details")}
                </h3>
                <div className="flex flex-col gap-4">
                  {appointData?.package_id.map((item, index) => (
                    <div
                      key={index}
                      className="border border-slate-150 rounded-2xl p-4 flex flex-col gap-4 hover:border-indigo-200 transition-colors duration-200"
                    >
                      <div className="flex items-start justify-between gap-4">
                        <div className="flex items-start gap-4">
                          <div className="w-14 h-14 rounded-2xl overflow-hidden border border-slate-150 shrink-0 bg-slate-50">
                            <ImageLoad
                              src={ImgBaseUrl + item.logo}
                              CustomeStyle="w-full h-full object-cover"
                              alt="logo"
                            />
                          </div>
                          <div className="flex-1 min-w-0">
                            <h4 className="font-bold text-slate-800 text-base">
                              {item.title}
                            </h4>
                            <p className="text-slate-500 text-sm mt-0.5">
                              {item.subtitle}
                            </p>
                            <span className="text-slate-400 text-xs font-semibold">
                              {t("Includes")} {item.tot_package_name}{" "}
                              {t("tests")}
                            </span>
                            <div className="flex items-center gap-3 mt-1.5">
                              <span className="text-slate-500 text-sm">
                                {t("Package Price")}:{" "}
                                <span className="font-semibold text-slate-700">
                                  {currency} {item.tot_package_price} x{" "}
                                  {item.f.length}
                                </span>
                              </span>
                              <span className="font-black text-indigo-600">
                                {currency}{" "}
                                {item.tot_package_price * item.f.length}
                              </span>
                            </div>
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            setPackageData(item);
                            setDetailsBox(true);
                          }}
                          className="w-9 h-9 flex items-center justify-center rounded-xl bg-indigo-50 border border-indigo-100 text-indigo-600 hover:bg-indigo-600 hover:text-white transition-all duration-200 shrink-0 active:scale-95"
                        >
                          <MdOutlineErrorOutline className="w-5 h-5" />
                        </button>
                      </div>

                      {/* Family member sliders */}
                      <div className="border-t border-slate-100 pt-4">
                        <span className="text-slate-400 text-xs font-bold uppercase tracking-wider block mb-3">
                          {t("Patients")}
                        </span>
                        <div className="patient-slider-container">
                          <Slider {...settings}>
                            {item.f.map((member, mIdx) => (
                              <div
                                key={mIdx}
                                className="px-1.5 focus:outline-none text-center"
                              >
                                <div className="flex flex-col items-center gap-2">
                                  <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-slate-200 shadow-inner">
                                    <ImageLoad
                                      src={
                                        ImgBaseUrl +
                                        member.fmember.profile_image
                                      }
                                      CustomeStyle="w-full h-full object-cover"
                                      alt="profile_image"
                                    />
                                  </div>
                                  <span className="font-bold text-slate-700 text-xs truncate max-w-[60px] block">
                                    {member.fmember.name}
                                  </span>
                                  <button
                                    onClick={() => HandleShowResport(member)}
                                    className={`text-[10px] font-bold text-white px-2.5 py-1 rounded-full transition-colors ${member.r.length === 0 ? "bg-slate-400" : "bg-indigo-600 hover:bg-indigo-700"}`}
                                  >
                                    {t("Report")}
                                  </button>
                                </div>
                              </div>
                            ))}
                          </Slider>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Column – Home Collector, Dates, Bill */}
            <div className="flex flex-col gap-6">
              {/* Home Collector Card */}
              {appointData?.home_c_user &&
                appointData?.home_c_email &&
                appointData?.home_c_phone && (
                  <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <LuUser className="w-5 h-5 text-indigo-600 shrink-0" />
                        <h3 className="font-bold text-slate-800 text-lg">
                          {t("Home Collector")}
                        </h3>
                      </div>
                      <button
                        onClick={() =>
                          AudioCallHandler(
                            appointData?.home_c_ccode,
                            appointData?.home_c_phone,
                          )
                        }
                        className="w-9 h-9 bg-indigo-50 border border-indigo-100 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-full flex items-center justify-center transition-all duration-200 active:scale-95"
                      >
                        <LuPhoneCall className="w-4 h-4" />
                      </button>
                    </div>
                    <div className="flex flex-col gap-2">
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-400 font-medium">
                          {t("Name")}
                        </span>
                        <span className="font-bold text-slate-700">
                          {appointData?.home_c_user}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-400 font-medium">
                          {t("Email")}
                        </span>
                        <span className="font-bold text-slate-700 truncate max-w-[130px]">
                          {appointData?.home_c_email}
                        </span>
                      </div>
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-400 font-medium">
                          {t("Phone")}
                        </span>
                        <span className="font-bold text-slate-700">
                          {appointData?.home_c_ccode}{" "}
                          {appointData?.home_c_phone}
                        </span>
                      </div>
                    </div>
                  </div>
                )}

              {/* Booking Date Card */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-3">
                <div className="flex items-center gap-2">
                  <LuCalendar className="w-5 h-5 text-indigo-600 shrink-0" />
                  <h3 className="font-bold text-slate-800 text-lg">
                    {t("Booking Date")}
                  </h3>
                </div>
                <div className="bg-slate-50 border border-slate-100 rounded-2xl p-3.5 text-sm font-semibold text-slate-700">
                  {appointData?.date}
                </div>
              </div>

              {/* Appointment Date Card */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-3">
                <div className="flex items-center gap-2">
                  <LuCalendar className="w-5 h-5 text-indigo-600 shrink-0" />
                  <h3 className="font-bold text-slate-800 text-lg">
                    {t("Appointment Date")}
                  </h3>
                </div>
                <div className="bg-slate-50 border border-slate-100 rounded-2xl p-3.5 text-sm font-semibold text-slate-700">
                  {formatDateTime(
                    appointData?.book_date,
                    appointData?.book_time,
                  )}
                </div>
              </div>

              {/* Bill Summary */}
              <div className="bg-white rounded-3xl border border-slate-150 p-6 shadow-sm flex flex-col gap-4">
                <div className="flex items-center gap-2">
                  <LuCreditCard className="w-5 h-5 text-indigo-600 shrink-0" />
                  <h3 className="font-bold text-slate-800 text-lg">
                    {t("Bill Summary")}
                  </h3>
                </div>
                <div className="flex flex-col gap-2.5 mt-1">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-slate-500 font-medium">
                      {t("Package Charge")}
                    </span>
                    <span className="font-bold text-slate-700">
                      {currency} {appointData?.tot_package_price}
                    </span>
                  </div>
                  {appointData?.home_extra_price !== 0 && (
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-slate-500 font-medium">
                        {t("Home Collection Fee")}
                      </span>
                      <span className="font-bold text-slate-700">
                        {currency} {appointData?.home_extra_price}
                      </span>
                    </div>
                  )}
                  {appointData?.coupon_amount !== 0 && (
                    <div className="flex items-center justify-between text-sm text-emerald-600 font-semibold">
                      <span>{t("Coupon Discount")}</span>
                      <span>
                        -{currency} {appointData?.coupon_amount}.0
                      </span>
                    </div>
                  )}
                  {appointData?.wallet_amount !== 0 && (
                    <div className="flex items-center justify-between text-sm text-emerald-600 font-semibold">
                      <span>{t("Wallet Payment")}</span>
                      <span>
                        -{currency} {appointData?.wallet_amount}.0
                      </span>
                    </div>
                  )}
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-slate-500 font-medium">
                      {t("Service Fee & Tax")}
                    </span>
                    <span className="font-bold text-slate-700">
                      {currency} {appointData?.site_commission}.0
                    </span>
                  </div>
                  {appointData?.payment_name &&
                    appointData?.payment_name !== "Cash" && (
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-slate-500 font-medium">
                          {t("Online Paid")} ({appointData?.payment_name})
                        </span>
                        <span className="font-bold text-slate-700">
                          {currency} {appointData?.online_amount}.0
                        </span>
                      </div>
                    )}
                  <div className="border-t border-dashed border-slate-100 my-1"></div>
                  <div className="flex items-center justify-between">
                    <span className="font-black text-slate-800 text-[15px]">
                      {t("Total Price")}
                    </span>
                    <span className="font-black text-indigo-600 text-lg">
                      {currency} {appointData?.tot_price}.0
                    </span>
                  </div>
                  {appointData?.transactionId && (
                    <div className="text-[11px] font-semibold text-slate-400 mt-1">
                      {t("Transaction ID")}:{" "}
                      <span className="font-mono text-slate-500">
                        {appointData?.transactionId}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ─── Order Status Modal ─────────────────────────────── */}
      {isShow && (
        <div
          onClick={() => setIsShow("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[80vh] scroll-container relative flex flex-col gap-4"
          >
            <button
              onClick={() => setIsShow("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>
            <div>
              <h2 className="font-bold text-slate-800 text-lg">
                {t("Order Status")}
              </h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">
                {t("Track your lab booking progress")}
              </p>
            </div>
            <Timeline
              sx={{
                [`& .${timelineOppositeContentClasses.root}`]: { flex: 0.2 },
                padding: 0,
              }}
            >
              {statusList.map((item, index) => {
                const status = Number(appointData?.status);
                const isFilled = status >= String(item.id);
                return (
                  <TimelineItem key={index}>
                    <TimelineOppositeContent color="textSecondary">
                      <span className="text-slate-400 text-[10px] font-semibold w-16 block leading-tight">
                        {item.date}
                      </span>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <div
                        style={{
                          backgroundColor: isFilled ? "#4f46e5" : "white",
                        }}
                        className="border border-slate-200 my-[11.5px] rounded-lg p-[3px] shadow-sm"
                      >
                        <MdCheck className="text-[14px] text-white" />
                      </div>
                      {statusList.length !== index + 1 && (
                        <TimelineConnector
                          style={{
                            backgroundColor: isFilled ? "#4f46e5" : "#e2e8f0",
                          }}
                        />
                      )}
                    </TimelineSeparator>
                    <TimelineContent>
                      <h4 className="font-bold text-slate-800 text-sm">
                        {t(item.title)}
                      </h4>
                      <p className="text-slate-400 text-xs mt-0.5 leading-relaxed">
                        {item.dis}
                      </p>
                    </TimelineContent>
                  </TimelineItem>
                );
              })}
            </Timeline>
          </div>
        </div>
      )}

      {/* ─── Package Details Modal ──────────────────────────── */}
      {detailsBox && (
        <div
          onClick={() => setDetailsBox("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-lg w-full max-h-[80vh] scroll-container relative flex flex-col gap-5"
          >
            <button
              onClick={() => setDetailsBox("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>
            <div>
              <h2 className="font-bold text-slate-800 text-lg">
                {t("Test Details & Package Details")}
              </h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">
                {t("Full package specifications")}
              </p>
            </div>

            <div className="flex flex-col gap-3 border-t border-dashed border-slate-100 pt-4">
              {/* Spec rows */}
              {[
                {
                  icon: (
                    <svg
                      width="22"
                      height="22"
                      className="text-slate-700"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 17.9668V10.1503C21 8.93937 20.4604 7.7925 19.5301 7.02652L14.5301 2.90935C13.0577 1.69688 10.9423 1.69689 9.46986 2.90935L4.46986 7.02652C3.53964 7.7925 3 8.93937 3 10.1503V17.9668C3 20.1943 4.79086 22 7 22H17C19.2091 22 21 20.1943 21 17.9668Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10 18H14"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                  ),
                  label: t("Home Collect Extra Price"),
                  value: `${currency} ${packageData?.home_extra_price}`,
                },
                {
                  icon: (
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      className="text-slate-700"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 17.928 6.072 22.75 12 22.75C17.928 22.75 22.75 17.928 22.75 12C22.75 6.072 17.928 1.25 12 1.25ZM12 21.25C6.899 21.25 2.75 17.101 2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 17.101 17.101 21.25 12 21.25ZM15.53 14.47C15.823 14.763 15.823 15.238 15.53 15.531C15.384 15.677 15.192 15.751 15 15.751C14.808 15.751 14.616 15.678 14.47 15.531L11.47 12.531C11.329 12.39 11.25 12.199 11.25 12.001V7.00098C11.25 6.58698 11.586 6.25098 12 6.25098C12.414 6.25098 12.75 6.58698 12.75 7.00098V11.6899L15.53 14.47Z"
                        fill="currentColor"
                      />
                    </svg>
                  ),
                  label: t("Test Report Time"),
                  value: packageData?.test_report_time,
                },
                {
                  icon: (
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      className="text-slate-700"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.53 20.47C21.823 20.763 21.823 21.238 21.53 21.531C21.384 21.677 21.192 21.751 21 21.751C20.808 21.751 20.616 21.678 20.47 21.531L15 16.061L12.88 18.1811C12.647 18.4151 12.334 18.5431 12 18.5431C11.666 18.5431 11.353 18.414 11.119 18.18L9.96999 17.0301C9.67699 16.7371 9.67699 16.262 9.96999 15.969C10.263 15.676 10.738 15.676 11.031 15.969L12.001 16.939L14.471 14.469C14.763 14.177 15.234 14.177 15.527 14.466L15.528 14.4651L15.531 14.468L15.537 14.474L21.53 20.47ZM6.96999 14.0301C7.11599 14.1761 7.30799 14.25 7.49999 14.25C7.69199 14.25 7.88399 14.1771 8.02999 14.0301C8.32299 13.7371 8.32299 13.262 8.02999 12.969L7.35998 12.299C5.94498 10.884 4.74999 7.99905 4.74999 5.99905V5.81002L8.479 9.54C8.625 9.686 8.817 9.76003 9.009 9.76003C9.201 9.76003 9.39299 9.687 9.53899 9.54C9.83199 9.247 9.83199 8.77203 9.53899 8.47903L4.52898 3.46902C4.45998 3.40002 4.377 3.34503 4.285 3.30703C4.102 3.23103 3.895 3.23103 3.712 3.30703C3.529 3.38303 3.38199 3.52904 3.30599 3.71304C3.26799 3.80504 3.24798 3.90202 3.24798 4.00002V6.00002C3.24798 8.41702 4.588 11.65 6.298 13.36L6.96999 14.0301ZM15.5 12.783C16.597 12.783 17.695 12.3651 18.53 11.5301L21.53 8.53005C21.823 8.23705 21.823 7.76202 21.53 7.46902C21.237 7.17602 20.762 7.17602 20.469 7.46902L17.469 10.469C16.383 11.555 14.615 11.555 13.53 10.469C13.004 9.94302 12.714 9.24305 12.714 8.49905C12.714 7.75505 13.004 7.05502 13.53 6.52902L16.53 3.52902C16.823 3.23602 16.823 2.76104 16.53 2.46804C16.237 2.17504 15.762 2.17504 15.469 2.46804L12.469 5.46804C11.659 6.27704 11.214 7.35301 11.214 8.49801C11.214 9.38801 11.49 10.232 11.991 10.946L2.46999 20.467C2.17699 20.76 2.17699 21.235 2.46999 21.528C2.61599 21.674 2.80799 21.748 2.99999 21.748C3.19199 21.748 3.38399 21.675 3.52999 21.528L13.053 12.005C13.787 12.519 14.641 12.783 15.5 12.783ZM14.351 8.16103C14.497 8.30703 14.689 8.38003 14.88 8.38003C15.072 8.38003 15.265 8.307 15.411 8.16L18.281 5.28005C18.573 4.98705 18.573 4.51202 18.279 4.21902C17.986 3.92702 17.51 3.92703 17.218 4.22103L14.348 7.10104C14.056 7.39404 14.057 7.86903 14.351 8.16103ZM15.851 9.66103C15.997 9.80703 16.189 9.88003 16.38 9.88003C16.572 9.88003 16.765 9.807 16.911 9.66L19.781 6.78005C20.073 6.48705 20.073 6.01202 19.779 5.71902C19.486 5.42702 19.01 5.42703 18.718 5.72103L15.848 8.60104C15.556 8.89404 15.557 9.36903 15.851 9.66103Z"
                        fill="currentColor"
                      />
                    </svg>
                  ),
                  label: t("Fasting Required"),
                  value: packageData?.fasting_require,
                },
              ].map((row, i) => (
                <div
                  key={i}
                  className="flex items-center justify-between bg-slate-50 border border-slate-100 rounded-2xl px-4 py-3"
                >
                  <div className="flex items-center gap-2.5">
                    {row.icon}
                    <span className="font-semibold text-slate-700 text-sm">
                      {row.label}
                    </span>
                  </div>
                  <span className="bg-indigo-50 border border-indigo-100 text-indigo-700 text-xs font-bold px-3 py-1 rounded-full">
                    {row.value}
                  </span>
                </div>
              ))}

              {/* Sample Types */}
              <div className="flex items-start justify-between bg-slate-50 border border-slate-100 rounded-2xl px-4 py-3">
                <div className="flex items-center gap-2.5">
                  <svg
                    width="22"
                    height="22"
                    className="text-slate-700"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.8887 6.1416L17.8583 11.1113L8.74728 20.2223C7.37494 21.5947 5.14995 21.5947 3.77761 20.2223C2.40528 18.85 2.40527 16.625 3.77761 15.2527L12.8887 6.1416Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                    <path
                      d="M17.03 3.65656C17.9449 2.74167 19.4282 2.74167 20.3431 3.65656C21.258 4.57145 21.258 6.05478 20.3431 6.96967L19.5148 7.79795L16.2017 4.48483L17.03 3.65656Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                    <path
                      d="M12.4744 3.24242C13.1605 2.55625 14.273 2.55625 14.9592 3.24242L20.7572 9.04036C21.4433 9.72653 21.4433 10.839 20.7572 11.5252C20.071 12.2114 18.9585 12.2114 18.2723 11.5252L12.4744 5.72725C11.7882 5.04108 11.7882 3.92859 12.4744 3.24242Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                    <path
                      d="M6 13L15 14"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span className="font-semibold text-slate-700 text-sm">
                    {t("Sample Type")}
                  </span>
                </div>
                <div className="flex flex-wrap gap-1.5 justify-end max-w-[55%]">
                  {packageData?.sample_type.map((item, index) => (
                    <span
                      key={index}
                      className="bg-indigo-50 border border-indigo-100 text-indigo-700 text-xs font-bold px-2.5 py-0.5 rounded-full"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Description */}
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  className="text-slate-800"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17 21.75H7C4.582 21.75 3.25 20.418 3.25 18V6C3.25 3.582 4.582 2.25 7 2.25H17C19.418 2.25 20.75 3.582 20.75 6V18C20.75 20.418 19.418 21.75 17 21.75ZM7 3.75C5.423 3.75 4.75 4.423 4.75 6V18C4.75 19.577 5.423 20.25 7 20.25H17C18.577 20.25 19.25 19.577 19.25 18V6C19.25 4.423 18.577 3.75 17 3.75H7ZM16.75 12C16.75 11.586 16.414 11.25 16 11.25H8C7.586 11.25 7.25 11.586 7.25 12C7.25 12.414 7.586 12.75 8 12.75H16C16.414 12.75 16.75 12.414 16.75 12ZM13.75 16C13.75 15.586 13.414 15.25 13 15.25H8C7.586 15.25 7.25 15.586 7.25 16C7.25 16.414 7.586 16.75 8 16.75H13C13.414 16.75 13.75 16.414 13.75 16ZM16.75 8C16.75 7.586 16.414 7.25 16 7.25H8C7.586 7.25 7.25 7.586 7.25 8C7.25 8.414 7.586 8.75 8 8.75H16C16.414 8.75 16.75 8.414 16.75 8Z"
                    fill="currentColor"
                  />
                </svg>
                <h4 className="font-bold text-slate-800">
                  {t("Package Description")}
                </h4>
              </div>
              <p className="text-slate-500 text-sm leading-relaxed pl-7">
                {packageData?.description}
              </p>
            </div>

            {/* Package Includes */}
            <div className="flex flex-col gap-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    className="text-slate-800"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.287 6.88198C21.286 6.87998 21.287 6.878 21.286 6.876C21.284 6.871 21.279 6.868 21.277 6.863C20.89 6.16 20.287 5.57999 19.525 5.24099L13.525 2.574C12.556 2.144 11.447 2.144 10.478 2.574L4.47803 5.24099C3.71503 5.57999 3.11295 6.16 2.72595 6.863C2.72395 6.868 2.71904 6.871 2.71704 6.876C2.71604 6.878 2.71694 6.87998 2.71594 6.88198C2.42294 7.42098 2.25305 8.02898 2.25305 8.66698V15.334C2.25305 16.814 3.12698 18.159 4.47998 18.761L10.48 21.428C10.962 21.642 11.479 21.748 11.996 21.75C11.999 21.75 12.001 21.751 12.004 21.751C12.007 21.751 12.009 21.75 12.012 21.75C12.529 21.749 13.046 21.642 13.528 21.428L19.528 18.761C20.881 18.16 21.755 16.815 21.755 15.334V8.66698C21.75 8.02898 21.58 7.41998 21.287 6.88198ZM11.0861 3.94399C11.3761 3.81499 11.689 3.74999 12 3.74999C12.311 3.74999 12.6239 3.81398 12.9139 3.94298L18.9139 6.60998C19.0839 6.68598 19.233 6.791 19.376 6.902L16.6429 8.11699L9.38403 4.7L11.0861 3.94399ZM7.573 5.505L14.832 8.92199L12.92 9.77199C12.334 10.027 11.663 10.027 11.085 9.77398L4.62402 6.902C4.76702 6.791 4.91606 6.68498 5.08606 6.60998L7.573 5.505ZM5.08606 17.389C4.27406 17.028 3.75 16.221 3.75 15.333V8.66598C3.75 8.50098 3.78595 8.343 3.81995 8.187L10.48 11.147C10.729 11.255 10.987 11.334 11.25 11.386V20.108C11.196 20.089 11.1391 20.078 11.0861 20.055L5.08606 17.389ZM20.25 15.333C20.25 16.221 19.7259 17.028 18.9139 17.389L12.9139 20.056C12.8609 20.08 12.804 20.09 12.75 20.109V11.386C13.014 11.333 13.274 11.254 13.524 11.145L15.879 10.098V11.89C15.879 12.304 16.215 12.64 16.629 12.64C17.043 12.64 17.379 12.304 17.379 11.89V9.432L20.179 8.18798C20.214 8.34498 20.249 8.50198 20.249 8.66698V15.333H20.25Z"
                      fill="currentColor"
                    />
                  </svg>
                  <h4 className="font-bold text-slate-800">
                    {t("Package Includes")}
                  </h4>
                </div>
                <span className="font-black text-indigo-600 text-base">
                  {currency}{" "}
                  {packageData?.package_price.reduce(
                    (acc, curr) => acc + curr,
                    0,
                  )}
                </span>
              </div>
              <div className="flex flex-col gap-2 pl-2">
                {packageData?.package_name.map((name, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between text-sm"
                  >
                    <span className="text-slate-600 font-medium">• {name}</span>
                    <span className="font-bold text-slate-700">
                      {currency} {packageData?.package_price[index]}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ─── Report Modal ───────────────────────────────────── */}
      {showReport && (
        <div
          onClick={() => setShowResport(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[80vh] scroll-container relative flex flex-col gap-5"
          >
            <button
              onClick={() => setShowResport(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>
            <div>
              <h2 className="font-bold text-slate-800 text-lg">
                {t("Lab Report")}
              </h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">
                {t("Patient diagnostic results")}
              </p>
            </div>

            <div className="flex items-center gap-4 p-3 bg-slate-50 border border-slate-100 rounded-2xl">
              <div className="w-14 h-14 rounded-2xl overflow-hidden border border-indigo-100 shrink-0">
                <ImageLoad
                  src={ImgBaseUrl + reportData?.fmember.profile_image}
                  CustomeStyle="w-full h-full object-cover"
                  alt="profile_image"
                />
              </div>
              <div>
                <h4 className="font-bold text-slate-800 text-base">
                  {reportData?.fmember.name}
                </h4>
                <p className="text-slate-400 text-xs font-medium mt-0.5">
                  {reportData?.d}
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-3">
              {reportData?.r.map((item, index) => {
                const imageExtensions = [
                  "png",
                  "jpg",
                  "jpeg",
                  "gif",
                  "bmp",
                  "webp",
                ];
                const itemSplit = item.split(".")[1];
                const isImage = imageExtensions.includes(itemSplit);
                return (
                  <div
                    key={index}
                    className="flex items-center gap-3 p-3 border border-slate-150 rounded-2xl bg-slate-50"
                  >
                    <div className="w-10 h-10 bg-indigo-50 border border-indigo-100 rounded-xl flex items-center justify-center shrink-0">
                      <MdPictureAsPdf className="text-indigo-600 text-xl" />
                    </div>
                    <span className="text-slate-700 text-sm font-semibold flex-1 truncate">
                      {item}
                    </span>
                    <div className="flex items-center gap-1.5 shrink-0">
                      <button
                        onClick={() => HandleShowReport(item)}
                        className="w-8 h-8 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full flex items-center justify-center transition-all duration-150 active:scale-90"
                      >
                        <MdOutlineRemoveRedEye className="text-base" />
                      </button>
                      {!isImage && (
                        <button
                          onClick={() => handleDownload(item)}
                          className="w-8 h-8 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full flex items-center justify-center transition-all duration-150 active:scale-90"
                        >
                          <MdOutlineFileDownload className="text-base" />
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {reportData?.c && (
              <div className="p-4 bg-slate-50 border border-slate-100 rounded-2xl">
                <span className="text-slate-400 text-xs font-bold uppercase tracking-wider block mb-1">
                  {t("Comment")}
                </span>
                <p className="text-slate-700 text-sm font-medium leading-relaxed">
                  {reportData?.c}
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ─── Device Check Modal ─────────────────────────────── */}
      {deviceCheck && (
        <div
          onClick={() => setDeviceCheck(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-sm w-full text-center"
          >
            <div className="w-12 h-12 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mx-auto mb-4 border border-amber-100">
              <LuPhoneCall className="w-6 h-6" />
            </div>
            <h2 className="font-bold text-slate-800 text-lg mb-2">
              {t("Audio Input Required")}
            </h2>
            <p className="text-slate-500 text-sm leading-relaxed">
              {t(
                "Required for voice and video calls. Make sure your audio device (headset, speakers, or microphone) is connected and working.",
              )}
            </p>
            <button
              onClick={() => setDeviceCheck(false)}
              className="mt-5 w-full py-2.5 bg-slate-900 hover:bg-slate-800 text-white font-semibold rounded-xl text-sm transition-all duration-150 active:scale-98"
            >
              {t("Got It")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PackageDetails;
/* jshint ignore:end */
